"use client";

const BlogBackground = () => {
  return (
    <>
      {/* left  */}
      <section
        className="pointer-events-none absolute inset-0"
        aria-hidden="true"
      >
        <div className="absolute top-[550px] left-[-83px] w-[313px] h-[172px] dark:bg-[#8593E8] bg-[#A1ADF5] rounded-full opacity-40 dark:opacity-20 blur-[100px]" />
        <div className="absolute top-[700px] left-[-136px] w-[417px] h-[170px] dark:bg-[#5D6EF3] bg-[#2A40E7] rounded-full opacity-40 dark:opacity-20 blur-[120px]" />
        <div className="absolute top-[850px] left-[-260px] w-[398px] h-[163px] dark:bg-[#FC4FF6] bg-[#FF8DFB] rounded-full opacity-40 dark:opacity-20 blur-[100px]" />
      </section>

      {/* right */}
      <section
        className="pointer-events-none absolute inset-0"
        aria-hidden="true"
      >
        <div className="absolute top-[1300px] right-[-153px] w-[313px] h-[272px] dark:bg-[#8593E8] bg-[#A1ADF5] rounded-full opacity-40 dark:opacity-20 -rotate-94 blur-[100px]" />
        <div className="absolute top-[1392px] right-[-180px] w-[274px] h-[315px] dark:bg-[#5D6EF3] bg-[#2A40E7] rounded-full opacity-40 dark:opacity-20 -rotate-94 blur-[120px]" />
        <div className="absolute top-[1580px] right-[-184px] w-[262px] h-[300px] dark:bg-[#FC4FF6] bg-[#FF8DFB] rounded-full opacity-40 dark:opacity-20 -rotate-94 blur-[100px]" />
      </section>
    </>
  );
};

export default BlogBackground;